import React, { FC, ReactNode } from 'react';
import Tooltip from 'antd/es/tooltip';
import Badge from 'antd/es/badge';

import useCanCreateContract from 'hooks/useCanCreateContract';

type TCustomTooltipProps = {
  route: string;
  children: ReactNode;
};

const completePaymentText = {
  contracts: 'Please complete your payment to enter this section.',
  settings: 'Please complete your payment.',
};

const TOOLTIP_OVERLAY_INNER_STYLE = {
  background: '#ffffff',
  color: '#0d0d0d',
  fontSize: 14,
  borderRadius: 8,
  boxShadow: '1px 4px 8px rgba(0, 0, 0, 0.12)',
  padding: '8px 16px',
};

export const CustomTooltip: FC<TCustomTooltipProps> = ({ route, children }) => {
  const canCreateContract = useCanCreateContract();

  if (!canCreateContract && ['settings', 'contracts'].includes(route)) {
    return (
      <Tooltip
        title={completePaymentText[route as keyof typeof completePaymentText]}
        placement='topLeft'
        color='#ffffff'
        overlayInnerStyle={TOOLTIP_OVERLAY_INNER_STYLE}
      >
        <Badge count='!' offset={[-8, 8]} style={{ backgroundColor: '#ff8282', fontFamily: 'aesthet-nova' }}>
          {children}
        </Badge>
      </Tooltip>
    );
  }
  return <>{children}</>;
};
